/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, meta: NonNullable<unknown>, description: NonNullable<unknown> }} Intro_Region_Option_AriaInputs */

const bn_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} ক্যাটাগরি পুল ${i?.description}`)
};

const de_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Kategoriepool ${i?.description}`)
};

const el_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Πισίνα κατηγορίας ${i?.description}`)
};

const en_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Category pool ${i?.description}`)
};

const es_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Grupo de categorías ${i?.description}`)
};

const fr_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Pool de catégorie ${i?.description}`)
};

const hi_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} श्रेणी पूल ${i?.description}`)
};

const hu_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Kategóriakészlet ${i?.description}`)
};

const id_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Kumpulan kategori ${i?.description}`)
};

const it_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Piscina di categorie ${i?.description}`)
};

const ja_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} カテゴリプール ${i?.description}`)
};

const ko_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} 카테고리 풀 ${i?.description}`)
};

const nl_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Categoriepool ${i?.description}`)
};

const pl_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Pula kategorii ${i?.description}`)
};

const pt_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Conjunto de categorias ${i?.description}`)
};

const ru_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Пул категорий ${i?.description}`)
};

const sv_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Kategoripool ${i?.description}`)
};

const tr_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Kategori havuzu ${i?.description}`)
};

const uk_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Пул категорій ${i?.description}`)
};

const vi_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} Nhóm danh mục ${i?.description}`)
};

const zh_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} 类别池 ${i?.description}`)
};

const zh_hant_intro_region_option_aria = /** @type {(inputs: Intro_Region_Option_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ${i?.meta} 類別池 ${i?.description}`)
};

/**
* | output |
* | --- |
* | "{label} {meta} Category pool {description}" |
*
* @param {Intro_Region_Option_AriaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_option_aria = /** @type {((inputs: Intro_Region_Option_AriaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Option_AriaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_option_aria(inputs)
	if (locale === "de") return de_intro_region_option_aria(inputs)
	if (locale === "el") return el_intro_region_option_aria(inputs)
	if (locale === "en") return en_intro_region_option_aria(inputs)
	if (locale === "es") return es_intro_region_option_aria(inputs)
	if (locale === "fr") return fr_intro_region_option_aria(inputs)
	if (locale === "hi") return hi_intro_region_option_aria(inputs)
	if (locale === "hu") return hu_intro_region_option_aria(inputs)
	if (locale === "id") return id_intro_region_option_aria(inputs)
	if (locale === "it") return it_intro_region_option_aria(inputs)
	if (locale === "ja") return ja_intro_region_option_aria(inputs)
	if (locale === "ko") return ko_intro_region_option_aria(inputs)
	if (locale === "nl") return nl_intro_region_option_aria(inputs)
	if (locale === "pl") return pl_intro_region_option_aria(inputs)
	if (locale === "pt") return pt_intro_region_option_aria(inputs)
	if (locale === "ru") return ru_intro_region_option_aria(inputs)
	if (locale === "sv") return sv_intro_region_option_aria(inputs)
	if (locale === "tr") return tr_intro_region_option_aria(inputs)
	if (locale === "uk") return uk_intro_region_option_aria(inputs)
	if (locale === "vi") return vi_intro_region_option_aria(inputs)
	if (locale === "zh") return zh_intro_region_option_aria(inputs)
	return zh_hant_intro_region_option_aria(inputs)
});